import z from 'zod'
import {
  nullSafeFirestoreTimestamp,
  nullSafeNumber,
  nullSafeString,
} from '../shared/schema'

export enum ClickWrapRole {
  instructor = 'instructor',
  participant = 'participant',
}

export enum ClickWrapState {
  draft = 0,
  active = 1,
  archived = 2,
}

export const schema = z.object({
  clickWrapDescription: nullSafeString(''),
  clickWrapName: nullSafeString(''),
  clickWrapRoles: z.nativeEnum(ClickWrapRole).array().default([]),
  clickWrapState: nullSafeNumber(ClickWrapState.draft),
  clickWrapUrl: nullSafeString(''),
  clickWrapDate: nullSafeFirestoreTimestamp(new Date()),
  updatedAt: nullSafeFirestoreTimestamp(new Date()),
})

export const empty = Object.freeze(
  schema.parse({
    clickWrapDescription: '',
    clickWrapName: '',
    clickWrapRoles: [],
    clickWrapState: ClickWrapState.draft,
    clickWrapUrl: '',
    clickWrapDate: { seconds: 0, nanoseconds: 0 },
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export interface FirestoreClickWrap extends z.infer<typeof schema> {}
